import React, { useEffect, useState, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import Select from "../FormComponents/Select/Select";

const AdditionalProtectionQuote = (props) => {
	const { renewalData, renewalId } = props;
	const dispatch = useDispatch();

	const changeLiability = (value) => {
		dispatch({
			type: "SET_LOADING_QUOTE",
			payload: true,
		});
		dispatch({
			type: "SET_LOADING_MONTHLY",
			payload: true,
		});
		const requestOptions = {
			method: "PUT",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify({ ...renewalData, liability_coverage: value }),
		};
		fetch(`/api/v2/quotes/${renewalId}`, requestOptions)
			.then((response) => response.json())
			.then((data) => {
				dispatch({
					type: "SET_QUOTE_DATA",
					payload: data.quote,
				});
				setTimeout(function () {
					dispatch({
						type: "SET_LOADING_QUOTE",
						payload: false,
					});
				}, 1500);
			});
	};

	const changeProperty = (value) => {
		dispatch({
			type: "SET_LOADING_MONTHLY",
			payload: true,
		});
		let isTrueSet = value === "true";
		const requestOptions = {
			method: "PUT",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify({ ...renewalData, covers_misc_damage: isTrueSet }),
		};
		fetch(`/api/v2/quotes/${renewalId}`, requestOptions)
			.then((response) => response.json())
			.then((data) => {
				dispatch({
					type: "SET_QUOTE_DATA",
					payload: data.quote,
				});
			});
	};

	const liabilityOptions = [
		<option value={false}>No</option>,
		<option value={1_000_000}>$1,000.000</option>,
		<option value={2_000_000}>$2,000.000</option>,
	];
	const miscOptions = [
		<option value={true}>Yes</option>,
		<option value={false}>No</option>,
	];
	return (
		<>
			<div className="col ml-4 otmt-2">
				<h2>Package Term</h2>
			</div>
			<div className="d-flex flex-column justify-content-center">
				<div className="col-12">
					<div className="col-md-6 mt-3">
						<Select
							classSelect="form-control"
							label="Level of Liability"
							options={liabilityOptions}
							classLabel="h5 text-uppercase"
							setVal={changeLiability}
							val={
								renewalData.liability_coverage
									? renewalData.liability_coverage
									: false
							}
						/>
					</div>
					<div className="col-md-6 mt-3">
						<Select
							classSelect="form-control"
							label="Misc Property Insurance"
							options={miscOptions}
							classLabel="h5 text-uppercase"
							setVal={changeProperty}
							val={
								renewalData.covers_misc_damage
									? renewalData.covers_misc_damage
									: false
							}
						/>
					</div>
				</div>
			</div>
		</>
	);
};

export default AdditionalProtectionQuote;
